
import { useNavigate } from 'react-router-dom';
import { SearchResult } from '@/types/search';

export const useSearchNavigation = () => {
  const navigate = useNavigate();

  const handleResultClick = (result: SearchResult) => {
    switch (result.type) {
      case 'page':
        navigate(result.data.path);
        break;
      case 'transaction':
        navigate('/transacoes', { 
          state: { 
            openTransactionId: result.id,
            searchNavigation: true 
          } 
        });
        break;
      case 'account':
        navigate('/contas', { 
          state: { 
            openAccountId: result.id,
            searchNavigation: true 
          } 
        });
        break;
      case 'card':
        navigate('/cartoes', { 
          state: { 
            openCardId: result.id,
            searchNavigation: true 
          } 
        });
        break;
      case 'goal':
        navigate('/metas', { 
          state: { 
            openGoalId: result.id,
            searchNavigation: true 
          } 
        });
        break;
      case 'category':
        navigate('/categorias', { 
          state: { 
            openCategoryId: result.id,
            searchNavigation: true 
          } 
        });
        break;
      case 'budget':
        navigate('/orcamentos', { 
          state: { 
            openBudgetId: result.id,
            searchNavigation: true 
          } 
        });
        break;
      case 'debt':
        navigate('/lancamentos', { 
          state: { 
            openDebtId: result.id,
            searchNavigation: true 
          } 
        });
        break;
      case 'future_release':
        navigate('/lancamentos', { 
          state: { 
            openFutureId: result.id,
            searchNavigation: true 
          } 
        });
        break;
    }
  };

  return { handleResultClick };
};
